__webpack_require__.p = "/DocSearch-Buddy/";